import { Injectable } from '@angular/core';
import { HttpClientWrapper } from './httpclientwrapper';
import { Observable } from 'rxjs';
import { AttbJobAlert } from '../models/attb-job-alert';
import { LoadingService } from '../services/loading.service';
import { ToasterMessageService } from './toaster-message.service';
import { AttbRegistration } from '../models/attb-registration';
import { ContextService } from './context-service';
import { IsAny } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { TotalJobAlert } from '@apply4u/models/total-job-alert';


@Injectable({
  providedIn: 'root'
})
export class AttbJobAlertService {
  constructor(private http: HttpClientWrapper,
    private loadingService: LoadingService,
    private toasterService: ToasterMessageService,
    private contextService: ContextService) {
  }

  GetAttbJobAlerts(id: number): Observable<any> {
    return this.http.GetAsync<any>(this.http.BaseUrl + "api/AttbJobAlerts/" + id);
  }

  GetAttbJobAlertsByUserId(userId: number): Observable<any> {
    return this.http.GetAsync<any>(this.http.BaseUrl + "api/AttbJobAlerts/search?userId=" + userId);
  }

  SaveAttbJobAlerts(attbJobAlert: AttbJobAlert): Observable<any> {
    return SaveAttbJobAlerts(this.http, attbJobAlert);
  }

  UpdateAttbJobAlerts(id: number, attbJobAlert: AttbJobAlert): Observable<any> {
    return this.http.PutAsync(this.http.BaseUrl + "api/AttbJobAlerts/attbJobAlertId?attbJobAlertId=" + id, attbJobAlert);
  }

  DeleteAttbJobAlerts(alertId: number): Observable<any> {
    return this.http.DeleteAsync(this.http.BaseUrl + "api/AttbJobAlerts/attbJobAlertId?attbJobAlertId=" + alertId);
  }

  SaveAttbAlerts(userId: number, jobTitle: string, location: string): Observable<any> {
    return SaveAttbAlerts(this.http, userId, jobTitle, location);
  }

  SearchJobAlert(frequencyId: number, desiredKewords: string, desiredLocation: string, radius: number, jobType: number, jobContract: number, minimumSalary: number, maximumSalary: number, userId: number, attbUserId: string, isDeletedFromAttb: number, recordStatus: number, success: number, attbSearchId: number): Observable<AttbJobAlert[]> {
    let params = "";
    
    if (frequencyId !== undefined && frequencyId != null && frequencyId != 0) {
      params += ((params.trim() == "") ? "?" : "&") + "frequencyId=" + frequencyId;
    }

    if (desiredKewords !== undefined && desiredKewords != null && desiredKewords.trim() != "") {
      params += ((params.trim() == "") ? "?" : "&") + "desiredKewords=" + desiredKewords;
    }

    if (desiredLocation !== undefined && desiredLocation != null && desiredLocation.trim() != "") {
      params += ((params.trim() == "") ? "?" : "&") + "desiredLocation=" + desiredLocation;
    }

    if (jobType !== undefined && jobType != null && jobType != 0) {
      params += ((params.trim() == "") ? "?" : "&") + "jobType=" + jobType;
    }

    if (jobContract !== undefined && jobContract != null && jobContract != 0) {
      params += ((params.trim() == "") ? "?" : "&") + "jobContract=" + jobContract;
    }

    if (minimumSalary !== undefined && minimumSalary != null) {
      params += ((params.trim() == "") ? "?" : "&") + "minimumSalary=" + minimumSalary;
    }

    if (maximumSalary !== undefined && maximumSalary != null) {
      params += ((params.trim() == "") ? "?" : "&") + "maximumSalary=" + maximumSalary;
    }

    if (userId !== undefined && userId != null && userId != 0) {
      params += ((params.trim() == "") ? "?" : "&") + "userId=" + userId;
    }

    if (attbUserId !== undefined && attbUserId != null && attbUserId.trim() != "") {
      params += ((params.trim() == "") ? "?" : "&") + "attbUserId=" + attbUserId;
    }

    if (isDeletedFromAttb !== undefined && isDeletedFromAttb != null) {
      params += ((params.trim() == "") ? "?" : "&") + "isDeletedFromAttb=" + isDeletedFromAttb;
    }

    if (recordStatus !== undefined && recordStatus != null) {
      params += ((params.trim() == "") ? "?" : "&") + "recordStatus=" + recordStatus;
    }

    if (success !== undefined && success != null) {
      params += ((params.trim() == "") ? "?" : "&") + "success=" + success;
    }

    if (attbSearchId !== undefined && attbSearchId != null && attbSearchId != 0) {
      params += ((params.trim() == "") ? "?" : "&") + "searchId=" + attbSearchId;
    }

    if (radius !== undefined && radius != null && radius != 0) {
      params += ((params.trim() == "") ? "?" : "&") + "radius=" + radius;
    }

    if (params === undefined || params == null || params.trim() == "") {
      params = "?userId=0";
    }

    //console.log("params:",params);
    return this.http.GetAsync<any>(this.http.BaseUrl + "api/AttbJobAlerts/search" + params);
  }

  SetJobGateJobAlert(jobAlertObj: any): Observable<any> {
    return SetJobGateJobAlert(this.http, jobAlertObj);
  }

  SetJobAlert(jobTitle: string, location: string) {
    SetJobAlert(this.http, this.contextService, this.toasterService, this.loadingService, jobTitle, location);
  }


  DisableAttbEmailAlerts(attbUserId: string) {
    return this.http.PutAsync(this.http.BaseUrl + "api/AttbJobAlerts/user/disableAttbAlerts/attbUserId?attbUserId=" + attbUserId, null);
  }

  EnableAttbAlerts(userId: number, alertFrequency: number) {

    return this.http.PutAsync(this.http.BaseUrl + "api/AttbJobAlerts/user/updateAlertFrequency/userId?userId=" + userId + "&alertFrequency=" + alertFrequency, null);
  }

  DeleteAttbRegistration(attbUserId: string) {
    return this.http.DeleteAsync(this.http.BaseUrl + "api/AttbJobAlerts/user/attbUserId?attbUserId=" + attbUserId);
  }

  GetAttbRegistration(userId: number): Observable<AttbRegistration> {
    return this.http.GetAsync(this.http.BaseUrl + "api/AttbJobAlerts/attbRegistration?userId=" + userId);
  }

}

export const SetJobGateJobAlert = (http: HttpClientWrapper, jobAlertObj: any): Observable<any> => {
  return http.PostAsync(http.BaseUrl + "api/affiliates/JobGateJobAlert/NewUser", jobAlertObj);
}

export const SearchJobAlert = (http: HttpClientWrapper, frequencyId: number, desiredKewords: string, desiredLocation: string, radius: number, jobType: number, jobContract: number, minimumSalary: number, maximumSalary: number, userId: number, attbUserId: string, isDeletedFromAttb: number, recordStatus: number, success: number, attbSearchId: number): Observable<AttbJobAlert[]> => {
  let params = "";
  
  if (frequencyId !== undefined && frequencyId != null && frequencyId != 0) {
    params += ((params.trim() == "") ? "?" : "&") + "frequencyId=" + frequencyId;
  }

  if (desiredKewords !== undefined && desiredKewords != null && desiredKewords.trim() != "") {
    params += ((params.trim() == "") ? "?" : "&") + "desiredKewords=" + desiredKewords;
  }

  if (desiredLocation !== undefined && desiredLocation != null && desiredLocation.trim() != "") {
    params += ((params.trim() == "") ? "?" : "&") + "desiredLocation=" + desiredLocation;
  }

  if (jobType !== undefined && jobType != null && jobType != 0) {
    params += ((params.trim() == "") ? "?" : "&") + "jobType=" + jobType;
  }

  if (jobContract !== undefined && jobContract != null && jobContract != 0) {
    params += ((params.trim() == "") ? "?" : "&") + "jobContract=" + jobContract;
  }

  if (minimumSalary !== undefined && minimumSalary != null) {
    params += ((params.trim() == "") ? "?" : "&") + "minimumSalary=" + minimumSalary;
  }

  if (maximumSalary !== undefined && maximumSalary != null) {
    params += ((params.trim() == "") ? "?" : "&") + "maximumSalary=" + maximumSalary;
  }

  if (userId !== undefined && userId != null && userId != 0) {
    params += ((params.trim() == "") ? "?" : "&") + "userId=" + userId;
  }

  if (attbUserId !== undefined && attbUserId != null && attbUserId.trim() != "") {
    params += ((params.trim() == "") ? "?" : "&") + "attbUserId=" + attbUserId;
  }

  if (isDeletedFromAttb !== undefined && isDeletedFromAttb != null) {
    params += ((params.trim() == "") ? "?" : "&") + "isDeletedFromAttb=" + isDeletedFromAttb;
  }

  if (recordStatus !== undefined && recordStatus != null) {
    params += ((params.trim() == "") ? "?" : "&") + "recordStatus=" + recordStatus;
  }

  if (success !== undefined && success != null) {
    params += ((params.trim() == "") ? "?" : "&") + "success=" + success;
  }

  if (attbSearchId !== undefined && attbSearchId != null && attbSearchId != 0) {
    params += ((params.trim() == "") ? "?" : "&") + "searchId=" + attbSearchId;
  }

  if (radius !== undefined && radius != null && radius != 0) {
    params += ((params.trim() == "") ? "?" : "&") + "radius=" + radius;
  }

  if (params === undefined || params == null || params.trim() == "") {
    params = "?userId=0";
  }

  //console.log("params:",params);
  return http.GetAsync<any>(http.BaseUrl + "api/AttbJobAlerts/search" + params);
}

export const SetJobAlert = (http: HttpClientWrapper, contextService: ContextService, toasterService: ToasterMessageService, loadingService: LoadingService, jobTitle: string, location: string) => {
  if (contextService.IsUserLoggedIn == false) {
    toasterService.Error(null, "You are not logged in, Please login to Set Email Alerts");
    return;
  }

  if (jobTitle === undefined || jobTitle == null) {
    jobTitle = "";
  }

  if (location === undefined || location == null) {
    location = "";
  }

  if (jobTitle.trim() == "" && location.trim() == "") {
    toasterService.Error(null, "No Keywords or location entered to set alerts");
    return;
  }

  loadingService.Show();
  SearchJobAlert(http, null, jobTitle.trim(), location.trim(), null, null, null, null, null, contextService.LoggedInUserId, null, null, 1, null, null).subscribe(result => {
    if (IsAny(result)) {
      loadingService.Hide();
      toasterService.Error(null, "Email Alert is already set for current search");
      return;
    }
    else {
      SaveAttbAlerts(http, contextService.LoggedInUserId, jobTitle.trim(), location.trim()).subscribe(result => {
        loadingService.Hide();
        toasterService.Success(null, "Email Alert Set Successfully");
        return;
      }, err => {
        loadingService.Hide();
        toasterService.Error(null, "Failed to set email alerts.");
        return;
      });
    }
  }, err => {
    loadingService.Hide();
  });
}

export const SaveAttbAlerts = (http: HttpClientWrapper, userId: number, jobTitle: string, location: string): Observable<any> => {
  let attbJobAlert = new AttbJobAlert();
  attbJobAlert.DesiredKewords = jobTitle;
  attbJobAlert.DesiredLocation = location;
  attbJobAlert.UserId = userId;
  attbJobAlert.FrequencyId = 1; //its daily by default
  return SaveAttbJobAlerts(http, attbJobAlert);
}

export const SaveAttbJobAlerts = (http: HttpClientWrapper,attbJobAlert: AttbJobAlert): Observable<any> => {
  return http.PostAsync<any>(http.BaseUrl + "api/AttbJobAlerts", attbJobAlert);
}

export const SetTotalJobAlert = (http: HttpClientWrapper, totalJobAlert: TotalJobAlert): Observable<any> => {
  return http.PostAsync(http.BaseUrl + "api/affiliates/totaljobs/createAlert", totalJobAlert);
}